<template>
  <div
    class="flex-fJend-fAend chantierAdd"
    :style="{ display: display }"
  >
    <input
      v-model="newTagName"
      type="text"
      :placeholder="placeholderTag"
    >
    <button
      type="reset"
      class="buttonIcon icon-cross"
      @click.prevent="cancel"
    />
    <button
      class="buttonIcon icon-validate"
      @click.prevent="add"
    />
  </div>
</template>
<script>
export default {
  props: {
    display: {
      type: String,
      default: ''
    },
    cartRowId: {
      type: String,
      default: ''
    },
    placeholderTag: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      newTagName: null
    }
  },
  methods: {
    add: function() {
      this.$emit('validate-add-tag', [this.cartRowId, this.newTagName, true])
    },
    cancel: function() {
      this.$emit('cancel-add-tag', this.cartRowId)
    }
  }
}
</script>
<style scoped>

  input {
    height: 3.2rem;
    min-width: 20rem;
    padding: 0.2rem;
    border-color: #9f9f9f;
    font-size: 1.4rem;
  }

  button,
  .buttonIcon {
    height: 3.2rem;
    min-width: 3.2rem;
    width: 3.2rem;
    padding: 0;
    margin: 0 0 0 0.2rem;
  }
  @media screen and (min-width: 940px) {
    .buttonIcon::before {
      position: inherit;
      top: unset;
      left: unset;
    }

    .buttonIcon::before {
      font-size: 1.4rem;
    }

    span.buttonIcon {
      margin-bottom: -0.1rem;
    }
  }

  @media screen and (max-width: 939px) {
    .buttonIcon::before {
      margin-right: 0;
    }
  }
</style>
